import React from 'react';
import { AuthProvider } from './context/AuthContext';

// Redux setting
import store from './app/store.js'
import { Provider } from 'react-redux'

import App from './App';
import LoadingProvider from "./context/loadingContext";
import {DrawerProvider} from "./context/DrawerContext";
import {Toaster} from "sonner";
import {ReactLenis} from "lenis/react";
import { NavbarProvider } from './context/NavbarContext.jsx';

import ReactDOM from 'react-dom/client';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Provider store={store} >
      <Toaster richColors position="top-center" />
      
        <AuthProvider>
          <LoadingProvider>
              <DrawerProvider>
                <NavbarProvider>
                  <ReactLenis root
                    options={{
                      lerp: 0.05, // Reduced from 0.1 for smoother interpolation
                      duration: 1.5, // Added duration for slower scrolling
                      smoothWheel: true, // Ensures smooth mouse wheel scrolling
                      wheelMultiplier: 0.8, // Reduced wheel sensitivity
                      touchMultiplier: 1.5, // Adjusted touch sensitivity
                      smooth: true // Ensures smooth scrolling is enabled
                    }}
                  >
                      <App />
                  </ReactLenis>
                </NavbarProvider>
              </DrawerProvider>
          </LoadingProvider>
      </AuthProvider> 
      
      
    </Provider>
  </React.StrictMode>
  
    
);